import { render, staticRenderFns } from "./leads.vue?vue&type=template&id=6e1ca2d3&scoped=true"
import script from "./leads.vue?vue&type=script&lang=js"
export * from "./leads.vue?vue&type=script&lang=js"
import style0 from "./leads.vue?vue&type=style&index=0&id=6e1ca2d3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e1ca2d3",
  null
  
)

export default component.exports